exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-link{\n    cursor: pointer;\n}\n\n#pagination{\n    display: flex;\n    justify-content: center;\n}", ""]);

